import React, { useContext, useState, useEffect } from "react";
import ArrowsDownUp from "../../../../icons/ArrowsDownUp";
import {
  Drawer,
  DrawerTrigger,
  DrawerContent,
} from "../../../../shadcn/components/ui/drawer";

import FilterSectionMobile from "./FilterSectionMobile";
import { Context, payloadToUrl } from "services";
import { useRouter } from "next/router";
interface MobileFilterSectionProps {
  handleClearFilters: any;
}

export default function MobileFilterSection({
  handleClearFilters,
}: MobileFilterSectionProps) {
  const router = useRouter();
  const { searchForm }: any = useContext(Context);
  const dropdownOptions = [
    { label: "All Properties", value: "all_properties" },
    { label: "Price: Low to high", value: "reserve_price_asc" },
    { label: "Price: High to low", value: "reserve_price_desc" },
    // { label: "Auction date (Approaching)", value: "auction_date_asc" },
  ];

  const [selected, setSelected] = useState<any | null>(
    searchForm.value.sort_by || null
  );
  const [open, setOpen] = useState<boolean>(false);

  useEffect(() => {
    if (searchForm.value.sort_by) {
      setSelected(searchForm.value.sort_by);
    }
  }, [searchForm.value.sort_by]);

  const handleSortingOptions = (data: any) => {
    setSelected(data);
    if (data.value === "all_properties") {
      handleClearFilters({ type: "all_properties" });
    }
    searchForm.setField("sort_by", data);
    setOpen(false);
  };

  return (
    <section className="grid grid-cols-2 items-center w-full py-[14px]">
      <Drawer open={open} onOpenChange={setOpen}>
        <DrawerTrigger asChild>
          <div className="flex justify-center items-center border-r-[1px] border-[#D3D3D3] cursor-pointer">
            <ArrowsDownUp />
            <div className="text-sm font-openSans capitalize text-brand-bgBlack pl-2">
              Sort by
            </div>
          </div>
        </DrawerTrigger>
        <DrawerContent>
          <div className="mx-auto w-full max-w-sm pb-12">
            <h3 className="py-5 text-lg font-semibold font-openSans">
              Sort By
            </h3>
            <div className="w-full flex flex-1 flex-col gap-2">
              {dropdownOptions.map((item: any, index: any) => (
                <div
                  key={`filter_data_${index}`}
                  className={`${
                    selected?.value === item.value
                      ? "bg-brand-lightOrange"
                      : "bg-white"
                  }  text-brand-textLightGrey text-base font-openSans p-1 rounded-lg`}
                  onClick={() => handleSortingOptions(item)}
                >
                  {item.label}
                </div>
              ))}
            </div>
          </div>
        </DrawerContent>
      </Drawer>
      <div>
        <FilterSectionMobile handleClearFilters={handleClearFilters} />
      </div>
    </section>
  );
}
